import React, { Component } from 'react';
import { CATEGORIES_LABEL } from '../../../../utils/clientConstant';

class InnerSubmenuWap extends Component {
  render() {
    const { text, className = '', handleClick } = this.props;

    return (
      <div className={`innerSubmenuBtnContainer ${className}`}>
        <button
          className="resetDefaultStyleBtn innerSubmenuBtn"
          onClick={handleClick}
        >
          {(text === CATEGORIES_LABEL) && (
            <span
              className="categoryIconInnerSubmenuWap"
              dangerouslySetInnerHTML={{ __html: this.props.icon }}
            />
          )}
          <span className='label-text-font'>{text}</span>
          <span
            className="chevron chevronLeft left chevronLeftInnerSubmenuWap"
            style={{
              marginTop: '0',
              position: 'absolute',
              right: '24px',
            }}
          />
        </button>
      </div>
    );
  }
}

export default InnerSubmenuWap;
